module.exports = __webpack_public_path__ + "static/media/tick-circle.af69b850.svg";